import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

function GoogleReviews() {
  return (
    <Container sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        ⭐ Customer Reviews
      </Typography>
      <iframe
        title="Google Reviews"
        src="https://www.google.com/maps/embed?pb=!1m2!2m1!1sscuba%20addicts%20sri%20lanka"
        width="100%"
        height="400"
        style={{ border: 0, borderRadius: "12px" }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </Container>
  );
}

export default GoogleReviews;
